/**
 * Toolbar entry point for the flythrough panel. Lights up while a tour from this
 * scope is playing, so the control still reads as active when the panel is shut.
 */
import { Film } from 'lucide-react'
import { ToolbarButton } from '@/components/overlay-ui'
import { useFlythroughStore } from './flythroughStore'

interface FlythroughButtonProps {
  scope: string
  open: boolean
  onToggle: () => void
  fullWidth?: boolean
  /** Render icon-only. */
  compact?: boolean
}

export function FlythroughButton({ scope, open, onToggle, fullWidth, compact }: FlythroughButtonProps) {
  const isPlaying = useFlythroughStore((s) => s.isPlaying && s.playingScope === scope)

  return (
    <ToolbarButton
      icon={<Film className="h-4 w-4" />}
      label={compact ? undefined : 'Flythrough'}
      accent="fuchsia"
      active={open || isPlaying}
      fullWidth={fullWidth}
      onClick={onToggle}
      title="Cinematic camera flythrough — capture shots and fly a smooth tour"
    />
  )
}
